import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import DrillDown from './DrillDown';
import { useDispatch } from 'react-redux';
import { resetAllDataOfPopUpOnTabChange } from '../../store/ShelfView/conflictsPage';
import GlobalSearch from './GlobalSearch';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
   
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

const SaveThumbnailsTabs = () => {
    const [value, setValue] = React.useState(0);
    const dispatch=useDispatch();
    const handleChange = (event, newValue) => {
      setValue(newValue);
      dispatch(resetAllDataOfPopUpOnTabChange())
    };
  return (
    <Box sx={{ width: '100%',}}>
    <Box sx={{}}>
      <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" >
        <Tab label="Drill down" {...a11yProps(0)} sx={{fontSize:"12px",}}/>
        <Tab label="Global Search" {...a11yProps(1)} sx={{fontSize:"12px"}} />
      </Tabs>
    </Box>
    <CustomTabPanel value={value} index={0}>
      <DrillDown />
    </CustomTabPanel>
    <CustomTabPanel value={value} index={1}>
      <GlobalSearch />
    </CustomTabPanel>
  </Box>
  )
}

export default SaveThumbnailsTabs